import React from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';

import { IconButton, Skeleton, Typography } from '@mui/material';
import Masonry from '@mui/lab/Masonry';

import { trpc } from '../api/trpc';
import { Group } from '../organisms/group';
import { Row } from '../atoms/row';
import { useSelector } from '../store/utils';
import { Link, Navigate, useParams } from 'react-router-dom';
import { ReportDetail } from '../templates/reports/report-detail';
import { ArrowLeft } from '../atoms/icons/arrow-left';
import { links } from '../paths';

const ReportDetailPage = () => {
  const { month } = useParams<{ month: string }>();
  if (!month) return <Navigate to="/" replace />;

  const premium = useSelector(({ variables: { PREMIUM } }) => PREMIUM);

  const { data, isLoading, isError } = trpc.reports.get.useQuery({ month });

  if (!premium) return <Navigate to="/" replace />;

  return (
    <>
      <Group layout="list">
        <Row gap={0.5}>
          <Link to={links.reports}>
            <IconButton size="small">
              <ArrowLeft sx={{ fontSize: '24px' }} />
            </IconButton>
          </Link>

          <Typography variant="h2" sx={{ textTransform: 'capitalize' }}>
            <FormattedDate
              value={new Date(month)}
              month="long"
              year="numeric"
            />
          </Typography>
        </Row>

        {isError && (
          <Typography color="error">
            <FormattedMessage
              id="error"
              defaultMessage="Chyba při načítání reportu."
            />
          </Typography>
        )}

        {isLoading && (
          <Masonry columns={{ xs: 1, md: 2 }} spacing={1}>
            <Skeleton variant="rounded" height={200} />
            <Skeleton variant="rounded" height={280} />
            <Skeleton variant="rounded" height={180} />
            <Skeleton variant="rounded" height={220} />
            <Skeleton variant="rounded" height={200} />
            <Skeleton variant="rounded" height={200} />
          </Masonry>
        )}

        {data && <ReportDetail month={month} report={data} />}
      </Group>
    </>
  );
};

export default ReportDetailPage;
